// extracted by mini-css-extract-plugin
export default {"filters":"ChangeHistory_filters__ybias","cell":"ChangeHistory_cell__uJBXF"};